import type { InjectionKey } from 'vue';
import type { IApiClient } from './types';
export const API_SYMBOL: InjectionKey<IApiClient> = Symbol();
